<a [href]="href" target="_blank" class="external-link">
    <ng-content></ng-content>
    <mat-icon svgIcon="external-link"></mat-icon>
</a>
